<template>
	<div class="container">
		<van-sticky>
		<div class="nav_h5">
			<div class="nav_box_h5"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="left">
					<img src="../assets/img/logo_color.png" @click="goIndex" />
				</div>
				<div v-if="!isShow" class="search_box" @click="goSearch">
					<van-icon name="search" color="#0B318F" size="20px" style="font-weight: bold;" />
				</div>
				<div class="right">
					<img v-if="!isShow" src="../assets/img/icon_nav.png" @click="showSlide" />
					<van-icon v-else name="cross" size="24px" color="#0B318F" @click="showSlide" />
				</div>
			</div>
			<!--折叠导航-->
			<div class="slide_box" :class="isShow ? 'height-slide' : ''">
				<div
					v-for="(value, index) in navData"
					:key="index"
					:class="pagename == value.catname ? 'actived' : ''"
					@click="navHandle(value)"
				>{{ value.catname }}</div>
				<div :class="pagename == 'Careers' ? 'actived' : ''" @click="navHandle2">Careers</div>
				<div @click="navHandleUrl('https://ne.ucsd.edu/')">Aiiso Dept.</div>
				<div @click="navHandleUrl('https://al21.com/')" style="color: #f16000;font-weight: bold;">
					<van-icon name="shopping-cart-o" class="icon_buy" size="22px" style="top: 4px;" /> Buy at @AL21
				</div>
				<div style="color: rgb(249, 150, 59);" @click="goSubscribe">Subscribe</div>
			</div>
			<!--折叠导航-->
		</div>
		</van-sticky>
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	props: ['pageName'],
	data() {
		return {
			//移动导航
			navData: JSON.parse(sessionStorage.getItem('navData')),
			isShow: false,
			pagename: this.pageName,
		}
	},
	created(){
		let that = this;
		if(!JSON.parse(sessionStorage.getItem('navData'))) {
			navList({language: 'en'}).then(res => {
				if(res.data.length > 0) {
					that.navData = res.data;
					sessionStorage.setItem('navData', JSON.stringify(res.data));
				}
			}).catch(() => {
				// Leave navigation available for a later retry.
			});
		}else {
			that.navData = JSON.parse(sessionStorage.getItem('navData'));
		}
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//跳转订阅
		goSubscribe() {
			let that = this;
			// window.location.href = 'https://pages.cordx.com/cordx-poc-newsletter';
			if(that.$route.path != '/cordx-poc-newsletter') {
				that.isShow = false;
				that.$router.push({ path: '/cordx-poc-newsletter', });
			}else {
				window.location.reload();
			}
		},
		//显示/隐藏导航
		showSlide() {
			let that = this;
			that.isShow = !that.isShow;
		},
		//跳转首页
		goIndex() {
			let that = this;
			if(that.$route.path != '/') {
				that.isShow = false;
				that.$router.push({ path: '/', });
			}
		},
		//跳转搜索
		goSearch() {
			let that = this;
			if(that.$route.path != '/search') {
				that.isShow = false;
				that.$router.push({ path: '/search', });
			}
		},
		//跳转导航
		navHandleUrl(path) {
			window.location.href = path;
		},
		navHandle2() {
			let that = this;
			if(that.$route.path != '/careers') {
				that.isShow = false;
				that.$router.push({ path: '/careers', });
			}
		},
		navHandle(value) {
			let that = this;
			if(that.$route.path != value.url) {
				// console.log(value.url);
				if(value.url == '/become-a-distributor') {
					that.isShow = false;
					// window.location.href = 'https://pages.cordx.com/become-a-distributor';
					that.$router.push({ path: '/become-a-distributor' });
				}else if(value.url == '/products'){
					if(that.$route.name == 'Products') {
						that.$router.push({ name: 'Products', params: { cateId: 'all', } });
						window.location.reload();
					}else {
						that.isShow = false;
						that.$router.push({ name: 'Products', params: { cateId: 'all', } });
					}
				}else {
					that.isShow = false;
					that.$router.push({ path: value.url, });
				}
			}
		},
	}
}
</script>

<style scoped>
/*导航*/
.nav_box_h5 {
	height: 70px;
	display: flex;
	align-items: center;
	position: relative;
	z-index: 1;
	background-color: #ffffff;
}

.nav_box_h5 .left {
	flex: 1;
	padding-left: 20px;
}

.nav_box_h5 .right {
	width: auto;
	padding-right: 20px;
}

.nav_box_h5 .left img {
	width: 150px;
	height: auto;
}

.nav_box_h5 .right img {
	width: 24px;
	height: auto;
}

.nav_box_h5 .search_box{
	position: absolute;
	right: 58px;
	padding-top: 10px;
}

.slide_box {
	position: absolute;
	z-index: 2;
	width: 100%;
	background-color: #ffffff;
	max-height: 0;
	transition: max-height 0.5s;
	overflow: hidden;
	height: 100vh;
	background-color: #ffffff;
}

.height-slide {
	max-height: 1000px;
}

.slide_box div{
	padding: 18px 22px;
	font-size: 20px;
}
.slide_box div.actived{
	background-color: #f5f8fa;
	color: #0B318F;
}
</style>
